document.addEventListener('DOMContentLoaded', () => {
  const collection = document.querySelector('.monodyne-collection');
  if (!collection) return;

  const cards = collection.querySelectorAll('.monodyne-collection__card');

  cards.forEach((card) => {
    const primary = card.querySelector('.monodyne-collection__image--primary');
    const secondary = card.querySelector('.monodyne-collection__image--secondary');
    const imageLink = card.querySelector('.monodyne-collection__image-link');

    if (!primary || !secondary) return;

    card.addEventListener('mouseenter', () => {
      primary.style.opacity = '0';
      secondary.style.opacity = '1';
    });

    card.addEventListener('mouseleave', () => {
      primary.style.opacity = '1';
      secondary.style.opacity = '0';
    });

    if (window.matchMedia('(hover: none)').matches && imageLink) {
      let showingBack = false;

      imageLink.addEventListener('click', (event) => {
        if (!showingBack) {
          event.preventDefault();
          primary.style.opacity = '0';
          secondary.style.opacity = '1';
          showingBack = true;
        }
      });
    }
  });

  const categoryBar = collection.querySelector('.monodyne-collection__categories');

  if (categoryBar) {
    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;

    categoryBar.addEventListener('mousedown', (event) => {
      isDown = true;
      startX = event.pageX - categoryBar.offsetLeft;
      scrollLeft = categoryBar.scrollLeft;
    });

    categoryBar.addEventListener('mouseleave', () => { isDown = false; });
    categoryBar.addEventListener('mouseup', () => { isDown = false; });

    categoryBar.addEventListener('mousemove', (event) => {
      if (!isDown) return;
      event.preventDefault();
      const x = event.pageX - categoryBar.offsetLeft;
      categoryBar.scrollLeft = scrollLeft - (x - startX) * 1.3;
    });
  }

  window.addEventListener('pageshow', () => {
    document.body.classList.add('monodyne-loaded');
  });
});
